import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IPaginationConfig } from './models/pagination-config.model';

@Component({
  selector: 'app-twq-pagination',
  templateUrl: './twq-pagination.component.html',
  styleUrls: ['./twq-pagination.component.scss']
})
export class TwqPaginationComponent  {
  @Input() config!: IPaginationConfig;

  @Output() pageIndexChange: EventEmitter<number> = new EventEmitter();
  constructor() { }

}
